import { render } from "./adminCreate.vue?vue&type=template&id=12379f08&scoped=true"
import script from "./adminCreate.vue?vue&type=script&lang=js"
export * from "./adminCreate.vue?vue&type=script&lang=js"

import "./adminCreate.vue?vue&type=style&index=0&id=12379f08&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12379f08"]])

export default __exports__